import {createRequest, makeRequest, prepareRequest, createPutRequest} from "../utils/apiUtil";

export function getById(id) {
    return makeRequest(createRequest('client/' + id));
}

export function update(formData, id) {
    return makeRequest(createPutRequest('client/' + id), formData);
}